import { render, staticRenderFns } from "./Preview1.vue?vue&type=template&id=2f82ef9f&"
import script from "./Preview1.vue?vue&type=script&lang=js&"
export * from "./Preview1.vue?vue&type=script&lang=js&"
import style0 from "./Preview1.vue?vue&type=style&index=0&id=2f82ef9f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports